import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  d: "M11.94 2.998c.547 3.191 2.603 6.203 5.28 7.926a8.23 8.23 0 0 0 2.724 1.146 8.2 8.2 0 0 0-2.306.863l-.384.225c-2.539 1.583-4.552 4.312-5.296 7.296a11.6 11.6 0 0 0-1.12-3.015c-1.097-2.12-2.793-3.815-4.942-4.868a7.5 7.5 0 0 0-1.385-.518c3.37-1.029 5.977-4.264 7.045-7.44a10 10 0 0 0 .384-1.615Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }